module.exports = __webpack_public_path__ + "img/esquemaJ.d67100e0.svg";